import styled, { css } from 'styled-components';
import { COLORS } from 'assets/styled/colors';
import { marginMd, marginSm, paddingMd } from 'assets/styled';
import { hoverLineIn } from 'assets/styled/commonStyles';
import { respondTo } from 'assets/styled/breakpoints';

interface StyledProps {
  clickable: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 50%;
  width: 100%;

  ${respondTo.midTablet`
    max-width: 100%;
  `}
`;

export const RowSpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${marginMd};

  ${respondTo.bigPhone`
    margin-bottom: 20rem;
  `}
`;

export const Heading = styled.div`
  font-size: 24rem;
  line-height: 36rem;
  font-weight: 300;
  color: ${COLORS.BLACK};
  margin-bottom: ${marginSm};

  ${respondTo.bigPhone`
    font-size: 18rem;
    line-height: 1.2;
  `}
`;

export const EditLabel = styled.label`
  font-weight: 300;
  font-size: 18rem;
  line-height: 27rem;
  color: ${COLORS.GREEN};
  cursor: pointer;
  ${hoverLineIn}
`;

export const BackgroundColorWrapper = styled.div`
  background-color: ${COLORS.WHITE};
  border-radius: 10rem;
  padding: ${paddingMd};
  height: 100%;

  ${respondTo.smallTablet`
    padding: 20rem;
  `}
`;

export const ContentWrapper = styled.div`
  display: flex;

  ${respondTo.bigPhone`
    flex-direction: column;
    gap: 30rem;
  `}
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20rem;

  ${respondTo.bigPhone`
    gap: 10rem;
  `}
`;

export const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Subtitle = styled.label`
  font-weight: 300;
  font-size: 16rem;
  line-height: 16rem;
  margin-bottom: 20rem;
  color: ${COLORS.BLACK};

  ${respondTo.bigPhone`
    padding-bottom: 10rem;
    margin-bottom: 10rem;
  `}
`;

export const LabelKey = styled.label`
  font-weight: 600;
  font-size: 14rem;
  line-height: 21rem;
  color: ${COLORS.BLACK};

  ${respondTo.bigPhone`
    font-size: 16rem;
  `}
`;

export const LabelValue = styled.label`
  font-weight: 300;
  color: ${COLORS.BLACK};
  font-size: 14rem;
  line-height: 21rem;
  ${({ clickable }: StyledProps) =>
    clickable &&
    css`
      cursor: pointer;
      text-decoration: underline;
    `}

  ${respondTo.bigPhone`
    font-size: 16rem;
  `}
`;

export const EditIcon = styled.div`
  cursor: pointer;
  position: absolute;
  width: 12rem;
  height: 12rem;
  right: -20rem;
  top: 1rem;
`;

export const ValueWrapperRelative = styled.div`
  position: relative;
  margin-right: ${marginSm};
  height: min-content;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
